import React from 'react'
import Spot from "../../../Spot";
import VideoHelper from "../../Components/VideoHelper";
import { volumeCheckSpotStates } from "./volumeCheckSpotStates";

const discoBall = require('../../../../../assets/studentPreChecks/DiscoBall.gif')
const bookVid = require('../../../../../assets/studentPreChecks/Book.mp4')
const multipleBooks = require('../../../../../assets/studentPreChecks/MulitpleBooks.gif')

/**
 * extend functionalities of the Spot component by composition
 */
export default function VolumeCheckSpot(props){

    const { state } = props

    if( state === volumeCheckSpotStates.discoBall ){
        return <VideoHelper videoSrc={discoBall} className="videoPlayerDiscoBall"/>
    }

    if( state === volumeCheckSpotStates.singleBook ){
        return <VideoHelper videoSrc={bookVid}/>
    }

    if( state === volumeCheckSpotStates.multipleBooks ){
        return <VideoHelper videoSrc={multipleBooks}/>
    }

    return <Spot spotState={state}/>
}